// 主布局：左侧 Sidebar + 固定 Header + 内容区（内容区由 PageContainer 控制 padding）
import { Outlet } from 'react-router-dom';
import { useSetupFlags } from '@/auth/RequireSetup';
import Sidebar from './Sidebar';
import Header from './Header';

export default function Layout() {
  const { mfaSetupRequired } = useSetupFlags();
  if (mfaSetupRequired) {
    return (
      <div className="flex h-screen bg-slate-50 text-slate-800 overflow-hidden">
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    );
  }
  return (
    <div className="flex h-screen bg-slate-50 text-slate-800 overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
